'use strict';

var dom = require('spa-dom'),
    tag = dom.tag;

module.exports = function () {
    var infoPanel = {};

    infoPanel.$body = tag(
        'div',
        {className: 'infoBlock'},

        infoPanel.$title = tag('div', {className: 'title'}),

        infoPanel.$panel = tag(
            'div',
            {className: 'infoContainer'},

            infoPanel.$country = tag('div', {className: 'country'}),

            tag(
                'div',
                {className: 'ratingContainer'},
                infoPanel.$ratingKino = tag('div', {className: 'ratingKino'}),
                infoPanel.$ratingImdb = tag('div', {className: 'ratingImdb'}),
                infoPanel.$censor = tag('div', {className: 'ageLimit'})
            ),

            tag(
                'div',
                {className: 'info'},

                tag(
                    'div',
                    {className: 'line'},
                    tag(
                        'div',
                        {className: 'left'},
                        tag('span', {}, gettext('Director:') + ' '),
                        infoPanel.$director = tag('div')
                    )
                ),

                tag(
                    'div',
                    {className: 'line double'},
                    tag(
                        'div',
                        {className: 'left'},
                        tag('span', {}, gettext('Cast:')),
                        infoPanel.$actors = tag('div')
                    )
                )
            ),

            infoPanel.$description = tag('div', {className: 'description'})
        ),

        tag(
            'div',
            {className: 'posterContainer'},
            infoPanel.$img = tag('div', {className: 'poster'})
        )
    );

    infoPanel.$info = tag('div', {className: 'information'});

    return infoPanel;
};
